// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueResource from 'vue-resource'
import { setupOpenwith } from '@/utils/openwith'
import { getQueryVariable } from '@/utils/common'
import { getUserInfo } from '@/utils/api.js'
import store from './store'
import i18n from './language'
import VuePlayerPlugin from 'vue-youtube-iframe-api'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VuePlayerPlugin)
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB_qlJxz2x6yJTUgN5AfRXK9YXU22gX6uQ',
        libraries: 'places' // This is required if you use the Autocomplete plugin
    },

    // // If you intend to programmatically custom event listener code
    // // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    // // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    // // you might need to turn this on.
    // autobindAllEvents: false,

    // // If you want to manually install components, e.g.
    // // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    // // Vue.component('GmapMarker', GmapMarker)
    // // then set installComponents to 'false'.
    // // If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
})
Vue.use(ElementUI)
Vue.use(Vant)

/* eslint-disable no-new */
const vueApp = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>',
    methods: {
        onDetectLanguage: function(localeValue) {
            let language = localeValue.value
            let code = 'en'
            if (typeof language === 'string' && language.startsWith('zh-')) {
                code = 'cn'
            }
            this.$i18n.locale = code
            this.$store.dispatch('setCountryData', code)
        },
        onDeviceReady: function() {
            if (window.cordova) {
                setupOpenwith(window.cordova, this)
            }

            navigator.globalization.getLocaleName(this.onDetectLanguage,
                function() {
                    console.log('Unable to detect locale.')
                }
            )

            navigator.globalization.getPreferredLanguage(this.onDetectLanguage,
                function() {
                    console.log('Unable to detect language.')
                }
            )

            window.handleOpenURL = function(url) {
                let token = getQueryVariable(url, 'token')
                if (token) {
                    localStorage.setItem('user_token', token)
                    localStorage.setItem('user_token_ts', new Date().getTime())
                    getUserInfo().then(res => {
                        store.state.userInfo = res.data
                    })
                }
            }
        }
    }
})
document.addEventListener('deviceready', vueApp.onDeviceReady)



// WEBPACK FOOTER //
// ./src/main.js